import { render, staticRenderFns } from "./approvalHome.vue?vue&type=template&id=25736ec4&scoped=true&"
import script from "./approvalHome.vue?vue&type=script&lang=js&"
export * from "./approvalHome.vue?vue&type=script&lang=js&"
import style0 from "./approvalHome.vue?vue&type=style&index=0&id=25736ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25736ec4",
  null
  
)

export default component.exports